<template>
  <Autocomplete
    v-model="model"
    :display-name="displayName"
    :debounce="1000"
    :loading="isLoading"
    @search="handleSearch"
  >
    <AutocompleteOption
      v-for="(item, index) in searchResult"
      :title="item.address"
      :subtitle="getSubtitle(item)"
      :value="item"
      :key="index"
    />
  </Autocomplete>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Autocomplete, AutocompleteOption } from '@tallo/design-system';
import { AddressDto } from '@tallo/property';

import addressService from '../services/address.service';

const model = defineModel<AddressDto | null>();
const searchResult = ref<AddressDto[]>([]);
const isLoading = ref(false);

function getSubtitle(item: AddressDto): string {
  const { city, state, zip } = item;
  return [city, state, zip].filter(Boolean).join(', ');
}

async function handleSearch(query: string) {
  if (!query) {
    searchResult.value = [];
    return;
  }

  isLoading.value = true;
  search(query);
}

async function search(query: string) {
  if (!query) {
    searchResult.value = [];
    return;
  }

  isLoading.value = true;

  try {
    searchResult.value = await addressService.addressAutocompleteGooglePlaces(query);
  } catch (err) {
    console.error(err);
  } finally {
    isLoading.value = false;
  }
}

function displayName(location: AddressDto): string {
  if (!location) {
    return '';
  }

  const { address, city, state, zip } = location;

  return [address, city, state, zip].filter(Boolean).join(', ');
}
</script>
